import React from "react";
import Head from "next/head";
import { NextPage } from "next";
import DefaultLayout from "common/Layouts/Default/Default";
import useHomeUrl from "pages/Errors/hooks/useHomeUrl";
import Header from "./components/Header/Header";
import Content from "./components/Content/Content";
import Footer from "./components/Footer/Footer";

type Props = { statusCode?: number; requestTraceId?: string };

const Page500: NextPage<Props> = ({ statusCode, requestTraceId }: Props) => {
  const url = useHomeUrl();

  return (
    <DefaultLayout
      header={<Header homeUrl={url} />}
      content={
        <>
          <Head>
            <title>500 Internal Server Error</title>
            <meta name="description" content="500 Internal Server Error" />
          </Head>
          <Content statusCode={statusCode} requestTraceId={requestTraceId} />
        </>
      }
      footer={<Footer homeUrl={url} />}
    />
  );
};

export default Page500;
